import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcArrowBack = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 17,
	viewBox: "0 0 18 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.66667 15.5L1 8.5M1 8.5L7.66667 1.5M1 8.5H17",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgIcArrowBack;
